import { Link } from 'react-router-dom'
import Meta from '../components/Meta'

const NewsletterScreen = () => {
  return (
    <>
      <Meta title="ニュースレター過去一覧 | オーダーTシャツ新着情報" />
      <div className="flex justify-center grow">
        <div className="screen-container mt-5 mb-14 w-full">
          <div className="text-sm breadcrumbs text-gray-500 mb-10">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>ニュースレターアーカイブ</li>
            </ul>
          </div>
          <div className="container">
            <h2 className="page-title">News Letters</h2>
            <p className="page-description">ニュースレターアーカイブ</p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-8">
              {/* オフホワイト */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202506_offwhite-tshirts.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2025年6月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/202506_offwhite/main.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">
                      オフホワイトカラー追加
                      <div className="badge badge-secondary">NEW</div>
                    </h2>
                    <p className="text-sm">
                      定番のミディアムウェイトとスムースにオフホワイトカラーを追加しました
                    </p>
                  </div>
                </Link>
              </div>

              {/* クラウドTシャツ */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202506_cloud-tshirts.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2025年6月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/202506_cloud/main.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">クラウドTシャツ</h2>
                    <p className="text-sm">
                      やらかさと滑らかさが特徴的なクラウドTシャツのご紹介です
                    </p>
                  </div>
                </Link>
              </div>

              {/* ダブルTシャツ */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202411_double-tshirts.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年11月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/double_img.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">ダブルTシャツ</h2>
                    <p className="text-sm">
                      厚手ながら軽く、保温性にも優れてダンボールニットを使用したダブルTシャツのご紹介です
                    </p>
                  </div>
                </Link>
              </div>

              {/* TシャツからロングTシャツに */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202411_tshirt-longtshirt.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年11月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/half-to-long.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">
                      TシャツからロングTシャツに
                    </h2>
                    <p className="text-sm">
                      ロングTシャツの購入に新規でサンプルの試着までは必要のないお客様へのサービスです
                    </p>
                  </div>
                </Link>
              </div>

              {/* ワッフルTシャツ */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202410_waffle-tshirt.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年10月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/waffle_img.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">ワッフルTシャツ</h2>
                    <p className="text-sm">
                      通常の天竺生地では表現できない個性があり、機能面でも優れたワッフルTシャツのご紹介です
                    </p>
                  </div>
                </Link>
              </div>

              {/* ５分袖、７分袖 */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202408_halfsleeve.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年8月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/sleeve_70.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">
                      ５分袖、７分袖オプション
                    </h2>
                    <p className="text-sm">
                      カスタマイズロングTシャツに袖丈を選択できる新しいオプションを追加しました
                    </p>
                  </div>
                </Link>
              </div>

              {/* パイルTシャツ */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202408_pile-tshirt.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年8月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/pile_img.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">パイルTシャツ</h2>
                    <p className="text-sm">
                      柔らかく肌触りが心地よく、吸水性に優れたタオル地でお馴染みのパイルTシャツのご紹介です
                    </p>
                  </div>
                </Link>
              </div>

              {/* ドライTシャツ */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202408_dry-tshirt.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年8月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/dry_img.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">ドライTシャツ</h2>
                    <p className="text-sm">
                      ポロシャツで使用される鹿の子生地を使った吸収速乾のドライTシャツのご紹介です
                    </p>
                  </div>
                </Link>
              </div>

              {/* ポンチTシャツ */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202407_ponte-tshirt.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年7月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/ponte_img.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">ポンチTシャツ</h2>
                    <p className="text-sm">
                      ハリとコシがあり、洗濯や乾燥による型崩れに強いポンチTシャツのご紹介です
                    </p>
                  </div>
                </Link>
              </div>

              {/* ニューカラー */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202407_newcolors.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年7月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/pink_smoke.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">ニューカラー</h2>
                    <p className="text-sm">
                      ミディアムに大人カジュアルにぴったりのモスピンクとホワイトスモークを追加しました
                    </p>
                  </div>
                </Link>
              </div>

              {/* 名入れ刺繍サービス */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202407_embroidery.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年7月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/embroidery_img.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">名入れ刺繍サービス</h2>
                    <p className="text-sm">
                      オーダーTシャツのオリジナル感と高級感がより高まる刺繍サービスのご紹介です
                    </p>
                  </div>
                </Link>
              </div>

              {/* ライトウェイトTシャツ */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202407_light-tshirt.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年7月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/light_img.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">
                      ライトウェイトTシャツ
                    </h2>
                    <p className="text-sm">
                      シルクのような肌触りと吸水性・放湿性に優れた軽い生地のライトウェイトTシャツのご紹介です
                    </p>
                  </div>
                </Link>
              </div>

              {/* シルキーTシャツ */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202406_silky-tshirt.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年6月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/newsletter/2024/silky_img.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">シルキーTシャツ</h2>
                    <p className="text-sm">
                      シルケット加工を施し、程よい光沢が上品なシルキーTシャツのご紹介です
                    </p>
                  </div>
                </Link>
              </div>

              {/* リニューアルのお知らせ */}
              <div className="card bg-base-100 shadow-sm border border-gray-300">
                <Link
                  to="https://mnsfabric.com/newsletters/202405_renewal.html"
                  className="hover:bg-gray-50"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <figure className="relative">
                    <span className="absolute top-3 right-3 bg-white py-1 px-4 rounded-full border border-gray-500 text-sm">
                      2024年5月
                    </span>
                    <img
                      src="https://mnsfabric.com/images/top-img-02.jpg"
                      alt="cloud T-shirts"
                    />
                  </figure>
                  <div className="card-body py-5">
                    <h2 className="card-title text-lg">
                      リニューアルのお知らせ
                    </h2>
                    <p className="text-sm">
                      オーダーTシャツ専門店として、よりお客様のニーズに応えるためにフルリニューアルいたしました
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NewsletterScreen
